const filterStatsCodecs = (codec: RTCRtpCodecParameters): boolean => codec.mimeType !== 'rtx';

export default filterStatsCodecs;
